import { makeAutoObservable } from 'mobx'

import { Collection } from '@flowwai-frontend/shared/sales-crm/sales-crm-core'

import NotificationModel from './models/NotificationModel'

export class NotificationsDoesNotExists extends Error {
   constructor(message: string) {
      super(message)
   }
}

class NotificationsStore {
   private _allNotifications!: Collection<string, NotificationModel>

   private _unReadNotifications!: Collection<string, NotificationModel>
   private _allNotificationsCount!: number
   private _unReadNotificationsCount!: number

   private constructor() {
      this.init()

      makeAutoObservable(this, {}, { autoBind: true })
   }

   private init(): void {
      this._allNotifications = new Collection<string, NotificationModel>(
         'The Notification you are trying to access does not exist'
      )

      this._unReadNotifications = new Collection<string, NotificationModel>(
         'The Notification you are trying to access does not exist'
      )

      this._unReadNotificationsCount = 0 // NOTE: setting default as 0
      this._allNotificationsCount = 0
   }

   get allNotifications(): NotificationModel[] {
      return this._allNotifications.items
   }

   get unReadNotifications(): NotificationModel[] {
      return this._unReadNotifications.items
   }

   get unReadNotificationsCount(): number {
      return this._unReadNotificationsCount
   }

   get allNotificationsCount(): number {
      return this._allNotificationsCount
   }

   addItemToAllNotifications(notification: NotificationModel): void {
      this._allNotifications.addItem(notification.notificationId, notification)
   }

   addItemToUnReadNotifications(notification: NotificationModel): void {
      this._unReadNotifications.addItem(
         notification.notificationId,
         notification
      )
   }

   removeItemFromAllNotifications(notificationId: string): void {
      this._allNotifications.deleteItem(notificationId)
   }

   removeItemFromUnReadNotifications(notificationId: string): void {
      this._unReadNotifications.deleteItem(notificationId)
   }

   getNotificationByIdFromAllNotifications(
      notificationId: string
   ): NotificationModel | null {
      const hasNotification = this._allNotifications.hasItem(notificationId)
      if (!hasNotification) return null
      return this._allNotifications.getItem(notificationId)
   }

   getNotificationByIdFromUnReadNotifications(
      notificationId: string
   ): NotificationModel | null {
      const hasNotification = this._unReadNotifications.hasItem(notificationId)
      if (!hasNotification) return null
      return this._unReadNotifications.getItem(notificationId)
   }

   convertToUnReadNotification(notificationId: string): void {
      const notificationModel = this._allNotifications.getItem(notificationId)
      notificationModel.setReadAt(null)
      this.addItemToUnReadNotifications(notificationModel)
   }

   setUnReadNotificationsCount(count: number): void {
      this._unReadNotificationsCount = count
   }

   setAllNotificationsCount(count: number): void {
      this._allNotificationsCount = count
   }

   clearAllNotifications(): void {
      this._allNotifications.clearData()
   }

   clearUnReadNotifications(): void {
      this._unReadNotifications.clearData()
   }

   clearStore(): void {
      this.init()
   }

   static create = (): NotificationsStore => new NotificationsStore()
}

export default NotificationsStore
